import { render } from "./employeeCalender.vue?vue&type=template&id=6d8338aa&scoped=true"
import script from "./employeeCalender.vue?vue&type=script&lang=js"
export * from "./employeeCalender.vue?vue&type=script&lang=js"

import "./employeeCalender.vue?vue&type=style&index=0&id=6d8338aa&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abbas\\Desktop\\kswc\\kswc_dashboard-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d8338aa"]])

export default __exports__